var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.elements[0].elementType,_vm._b({tag:"component",attrs:{"pointer":"1"}},'component',_vm.elements[0],false))}
var staticRenderFns = []

export { render, staticRenderFns }